module.exports = __webpack_public_path__ + "img/artboard–2.0479f8b2.png";